import { BoxProps, Box as MuiBox, Theme, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useIsTokenValid } from "src/api/auth";
import { MapContext } from "src/contexts/map";
import { SETTINGS_TAG, URL_LOGIN } from "src/router/routes";

import MobileViewDrawer from "./mobile/MobileViewDrawer";
import SearchBar from "./SearchBar";
import UserManger from "./UserManager";
import FilterElements from "./web/FilterElements";
import LayersList from "./web/LayersList";
import SwitchView from "./web/SwitchView";

const OuterBox = styled(MuiBox)<BoxProps>(({ theme }) => ({
    width: "100%",
    height: theme.spacing(8),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px 4px 4px -2px rgba(0, 0, 0, 0.1)",
}));

const InnerBox = styled(MuiBox)<BoxProps>(() => ({
    width: "98%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
}));

const Box = styled(MuiBox)<BoxProps>(({ theme }) => ({
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    gap: theme.spacing(2),
    height: theme.spacing(6),
}));

const Header = () => {
    const { updateAuthStatus, updateConnectedUser } = useContext(MapContext);
    const token = sessionStorage.getItem("authToken");

    const { data, isFetched } = useIsTokenValid(token || "");

    const { schema } = useParams<{ schema: string }>();

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (data && isFetched) {
            updateAuthStatus(!!data.valid);
            updateConnectedUser(data.user);
        } else {
            updateAuthStatus(false);
        }
    }, [data, token, isFetched]);

    useEffect(() => {
        const isPublic = import.meta.env._WITH_PUBLIC === "true";

        if (isPublic) navigate(location.pathname);
        if (!isPublic && isFetched) {
            if (!!data?.valid === false) navigate(`/${schema}${URL_LOGIN}`);
            else navigate(location.pathname);
        }
    }, [isFetched, schema]);

    const isMobile = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("md"),
    );

    const isSettingPage = location.pathname.includes(SETTINGS_TAG);

    return (
        <OuterBox>
            <InnerBox>
                <Box>
                    {isMobile && <MobileViewDrawer />}
                    <MuiBox component="img" src="/static/images/logo.svg" />
                    {!isMobile && !isSettingPage && (
                        <>
                            <SearchBar />
                            <FilterElements />
                            <LayersList />
                        </>
                    )}
                </Box>

                <Box>
                    {!isMobile && <SwitchView />}
                    <UserManger />
                </Box>
            </InnerBox>
        </OuterBox>
    );
};

export default Header;
